import { POSITION_CHANNEL_PREFIX } from '../constants';

function createPositionChannel(pamCode: string) {
  return `${POSITION_CHANNEL_PREFIX}${pamCode}`;
}

export { createPositionChannel };
